import React from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { FormikInput, ButtonTooltip, Icon } from '../../../components';

const getRows = choices => choices.filter(c => !c._destroy && c.kind === 'row');
const getCols = choices => choices.filter(c => !c._destroy && c.kind === 'column');

export const StructuredMatrixLayout = ({ valuePath, questionChoicesAttributes = [], addRow, addCol, deleteChoice }) => {
  const { errors, touched } = useFormikContext();

  const rows = getRows(questionChoicesAttributes);
  const cols = getCols(questionChoicesAttributes);

  const realIndex = choice => questionChoicesAttributes.findIndex(c => c === choice);

  return (
    <div className="mt-3">
      {/* Pregunta */}
      <Row>
        <Col md={10}>
          <Field name={`${valuePath}[label]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Pregunta"
                maxLength={100}
                tooltipText="Máximo 100 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      {/* Descripción */}
      <Row>
        <Col md={6}>
          <Field name={`${valuePath}[description]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                label="Descripción opcional"
                maxLength={300}
                placeholder="Seleccione una respuesta en cada fila"
                tooltipText="Máximo 300 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      {/* ---- Matrix grid ---- */}
      <div className="mt-3 table-responsive">
        <table className="table table-bordered matrix-table">
          <thead>
            <tr>
              {/* empty top-left cell */}
              <th className="matrix-th-empty" />

              {/* Column headers — editable inputs */}
              {cols.map(col => {
                const ri = realIndex(col);
                return (
                  <th key={ri} className="matrix-th-col">
                    <div className="matrix-col-header">
                      <Field name={`${valuePath}[questionChoicesAttributes][${ri}][label]`}>
                        {({ field }) => (
                          <FormikInput
                            {...field}
                            value={field.value || ''}
                            maxLength={50}
                            placeholder="Columna"
                            customFormGroupClass="matrix-col-input mb-0"
                          />
                        )}
                      </Field>
                      <ButtonTooltip
                        variant="circle-danger"
                        className="btn-circle"
                        size="sm"
                        text="Eliminar columna"
                        onClick={() => deleteChoice(ri)}
                        disabled={cols.length <= 1}
                      >
                        <Icon icon="trash" />
                      </ButtonTooltip>
                    </div>
                  </th>
                );
              })}

              {/* delete placeholder — spacing */}
              <th className="matrix-th-actions" />
            </tr>
          </thead>

          <tbody>
            {rows.map(row => {
              const ri = realIndex(row);
              return (
                <tr key={ri}>
                  {/* Row label — editable input */}
                  <td className="matrix-td-row-label">
                    <Field name={`${valuePath}[questionChoicesAttributes][${ri}][label]`}>
                      {({ field }) => (
                        <FormikInput
                          {...field}
                          value={field.value || ''}
                          maxLength={50}
                          placeholder="Fila"
                          customFormGroupClass="matrix-row-input mb-0"
                        />
                      )}
                    </Field>
                  </td>

                  {/* One disabled radio per column */}
                  {cols.map(col => (
                    <td key={realIndex(col)} className="text-center matrix-td-radio">
                      <Form.Check type="radio" disabled />
                    </td>
                  ))}

                  {/* Delete row button */}
                  <td className="text-center matrix-td-actions">
                    <ButtonTooltip
                      variant="circle-danger"
                      className="btn-circle"
                      size="sm"
                      text="Eliminar fila"
                      onClick={() => deleteChoice(ri)}
                      disabled={rows.length <= 1}
                    >
                      <Icon icon="trash" />
                    </ButtonTooltip>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Action buttons */}
      <Row className="mt-2">
        <Col className="d-flex justify-content-end matrix-actions-col">
          <Button variant="secondary" size="sm" onClick={addRow}>
            Agregar Fila
          </Button>
          <Button variant="primary" size="sm" onClick={addCol}>
            Agregar Columna
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default StructuredMatrixLayout;
